import React from "react";

import "./Forms.scss";
// add .error to component for error state.

const Radio = (props) => {
  const {
    isChecked,
    customDivStyle,
    customInputStyle,
    customLabelStyle,
    ...otherProps
  } = props;
  return (
    <div className="form-field" style={customDivStyle || {}}>
      <input
        type="radio"
        {...otherProps}
        checked={isChecked}
        style={customInputStyle || {}}
      />
      <label htmlFor={props.id} style={customLabelStyle || {}}>
        {props.label}
      </label>
    </div>
  );
};
export default Radio;
